<template>
  <v-btn rounded @click="connectInstagram" width="260px" class="white--text ma-1" color="instagram">
    <v-icon left color="white" medium>mdi-instagram</v-icon>Connect with instagram
  </v-btn>
</template>
<script>
// import utils from '@/utils';
// import apiURLs from '@/config/APIs';
import config from '@/config';
export default {
  computed: {
    facebookId() {
      return this.$store.state.user.facebookId;
    },
    userId() {
      return this.$store.state.user.id;
    }
  },
  name: 'ConnectInstagram',
  methods: {
    async connectInstagram(data = {}) {
      let reqObj = {
        client_id: config.INSTAGRAM_CLIENT_ID,
        redirect_uri: config.INSTAGRAM_LOGIN_REDIRECT_URL,
        scope: 'instagram_business_basic',
        response_type: 'code'
      }
      reqObj = Object.keys(reqObj)
      .map(key => `${key}=${reqObj[key]}`)
      .join('&')
      window.location.href = config.INSTAGRAM_APP_AUTHORIZE_URL + '?' + reqObj
    }
  }
};
</script>



// WEBPACK FOOTER //
// ConnectInstagram.vue?df795206